// extracted by mini-css-extract-plugin
export default {"list":"Audios_list__MQw5J","link":"Audios_link__SNufs","title":"Audios_title__pSQqp"};